import styled, { css } from 'styled-components';

import { TabsContainer } from './TabsContainer';
import { Modal } from '../atoms/modal';
import { grey } from '../../theme/colors';

export const StyledTabsContainer = styled(TabsContainer)`
  table tr:nth-of-type(odd) td {
    background: #f7f7f7 !important;
  }
`;

export const InvisibleButton = styled('button')<{ visibilityHidden?: boolean; top?: string; left?: string }>`
  ${({ visibilityHidden, top, left }) =>
    visibilityHidden
      ? css`
          visibility: hidden;
          height: 0;
          width: 0;
          offset: none;
          border: none;
          appearance: none;
          overflow: hidden;
          position: absolute;
          z-index: -1;
          left: ${left};
          top: ${top};
        `
      : css`
          display: none;
        `}
`;

export const MatchEditorRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
`;

export const InvisibleContainer = styled.div`
  width: 56px;
  visibility: hidden;
`;

export const MatchEditorModal = styled(Modal)`
  max-height: 70vh;
  overflow: auto;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0px 0px 12px 6px rgba(0, 0, 0, 0.1);
  padding: 24px 32px;
`;

export const CheckboxWrapper = styled.div`
  > div {
    margin-left: 16px;
  }
`;
